/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fridge_medium'
export default icon
